import { facets } from "../facets.js";

export const createCustomLabels = (filters) => {
  return filters
    .map((f) => {
      const filter = facets[f.key];
      if ("rangeSlider" === filter.type) {
        return [filter.attribute, filter.label];
      } else {
        return [false, false];
      }
    })
    .filter((a) => a[0]);
};
